import Card from "components/Card/Card";
import CardBody from "components/Card/CardBody";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import ClientHelper from "core/ClientHelper";
import PropTypes from "prop-types";
import React from "react";
import ButtonToolbar from "views/Components/ButtonToolbar";
import { GenericDateInput, GenericExpansionPanel, GenericGrid, GenericSelectInput, GenericTextInput } from "views/Components/Generic";
import { GridColumnType } from "views/Constants/Constant";

class UserLogReport extends React.Component {
	constructor(props) {
		super(props);

		this.columns = [
			{
				Header: "Modified Date",
				accessor: "InsertDateTime",
				type: GridColumnType.DateTime
			},
			{
				Header: "Category Name",
				accessor: "CategoryName"
			},
			{
				Header: "Table Name",
				accessor: "TableName"
			},
			{
				Header: "Modified Field",
				accessor: "ColumnName"
			},
			{
				Header: "Original Value",
				accessor: "OriginalValue"
			},
			{
				Header: "New Value",
				accessor: "NewValue"
			},
			{
				Header: "Modified User",
				accessor: "InsertUser"
			}
			,
			{
				Header: "Customer Name",
				accessor: "CustomerName"
			},
			{
				Header: "Customer Number",
				accessor: "CustomerNumber"
			}
		];

		this.uniqueClientId = ClientHelper.GetClientRowId();

		this.emptyObject = {};
		this.parameterUniqueClientId = {};

		this.sortedFullName = { Member: "FullName" };

		this.validateProperties = [{ "UserId": "User" }];

		this.state = {
			model: {
				UniqueClientId: this.uniqueClientId
			}
		};
	}

	componentDidMount() {
		const { setAppLeftTitle, setAppCenterTitle } = this.props;

		if (setAppCenterTitle) {
			setAppCenterTitle("LOAN MANAGEMENT SYSTEM");
		}
		if (setAppLeftTitle) {
			setAppLeftTitle("User Log Report");
		}
	}

	ValueChanged = (name, value) => {
		this.setState(state => {
			var model = state.model;
			model[name] = value;

			return { model };
		});
	}

	GetParameterUniqueClientId = () => {
		const { model } = this.state;

		this.parameterUniqueClientId.UniqueClientId = model.UniqueClientId;

		return this.parameterUniqueClientId;
	}

	Search = async () => {
		const { model } = this.state;
		const { ExecuteApiPost } = this.props;
		var result = await ExecuteApiPost("/coreapi/v1.0/AuditLogView/Search", model, model, this.validateProperties);

		this.setState({ list: result || [] });
	}

	Clear = () => {
		this.setState({ model: { UniqueClientId: this.uniqueClientId }, list: [] });
	}

	render() {
		const { Disabled } = this.props;
		const { model, list } = this.state;

		return (
			<div>
				<ButtonToolbar
					ButtonList={[
						{
							Code: "Search",
							Disabled: Disabled,
							OnClick: this.Search
						},
						{
							Code: "Clear",
							Disabled: Disabled,
							OnClick: this.Clear
						}
					]}
					menuId={this.props.menuId}
					ApprovalData={this.props.ApprovalData}
					After={this.props.After} />
				<GridContainer>
					<GridItem xs={12}>
						<Card className="no-radius">
							<CardBody>
								<GenericExpansionPanel Title="User Log Report">
									<GridContainer>
										<GridItem xs={4}>
											<GenericSelectInput
												Disabled
												Name="UniqueClientId"
												LabelText="Client"
												Url="/lmsapi/v1.0/UserLogReport/SearchClient"
												Method="POST"
												Parameter={this.emptyObject}
												DataRoot="Item"
												KeyValueMember="UniqueClientId"
												TextValueMember="Name"
												Value={model.UniqueClientId}
												ValueChanged={this.ValueChanged} />
											<GenericDateInput
												Utc
												Name="DateFrom"
												LabelText="Start Date"
												Value={model.StartDate}
												ValueChanged={this.ValueChanged} />
											{/* <GenericTextInput
												Name="TableName"
												LabelText="Table Name"
												Value={model.TableName}
												ValueChanged={this.ValueChanged} /> */}
											<GenericTextInput
												Name="OriginalValue"
												LabelText="Original Value"
												Value={model.OriginalValue}
												ValueChanged={this.ValueChanged} />
										</GridItem>
										<GridItem xs={4}>
											<GenericSelectInput
												Required
												IsInvalid={model.IsUserId}
												key={model.UniqueClientId}
												Name="UserId"
												LabelText="User"
												Url="/coreapi/v1.0/User/Search"
												Method="POST"
												Parameter={this.GetParameterUniqueClientId()}
												DataRoot="Item"
												KeyValueMember="Id"
												TextValueMember="FullName"
												Sorted={this.sortedFullName}
												Value={model.UserId}
												ValueChanged={this.ValueChanged} />
											<GenericDateInput
												Utc
												Name="DateTo"
												LabelText="End Date"
												Value={model.EndDate}
												ValueChanged={this.ValueChanged} />
											{/* <GenericTextInput
												Name="ColumnName"
												LabelText="Column Name"
												Value={model.ColumnName}
												ValueChanged={this.ValueChanged} /> */}
											<GenericTextInput
												Name="NewValue"
												LabelText="New Value"
												Value={model.NewValue}
												ValueChanged={this.ValueChanged} />
										</GridItem>
										<GridItem xs={4}>

										</GridItem>
									</GridContainer>
								</GenericExpansionPanel>
							</CardBody>
						</Card>
						<Card className="no-radius">
							<CardBody>
								<GenericGrid
									Data={list}
									Columns={this.columns}
									ShowPagination={true}
									PageSize={100}
									Sorted={[{ id: "TransactionDate", desc: true }]} />
							</CardBody>
						</Card>
					</GridItem>
				</GridContainer>
			</div>
		);
	}
}

UserLogReport.propTypes = {
	setAppLeftTitle: PropTypes.func,
	setAppCenterTitle: PropTypes.func,
	ExecuteApiPost: PropTypes.func,
	Disabled: PropTypes.bool,
	ApprovalData: PropTypes.any,
	After: PropTypes.any
};

export default UserLogReport;